import CryptoJs from 'crypto-js';
import q from 'q';
import axios from 'axios';
import querystring from 'querystring';

// Initialize Constants
const ISSUER_TOKEN_TIMEOUT_THRESHOLD = 60; // seconds (Unix Time)
const ISSUER = process.env.ISSUER;
const CLIENT_ID = process.env.OIDC_APP_CLIENT_ID;
const CLIENT_SECRET = process.env.OIDC_APP_CLIENT_SECRET;
const GRANT_TYPE = process.env.OIDC_APP_GRANT_TYPE;
const SESSION_STORE_TOKEN_SET = 'TokenSet';

const thresholdNotPassed = expiresTime => {
  return expiresTime - (new Date().getTime() / 1000) >= ISSUER_TOKEN_TIMEOUT_THRESHOLD;
};

/**
 * Return a policy/zip access token for API authorization
 *
 * @param {String} policyNumber - the policy number needed for the access token.
 * @param {String} zipCode - the zip code needed for the access token.
 * @returns {Promise} for the bearer access token
 */
const grantNewToken = (policyNumber, zipCode) => {
  let hash = CryptoJs.HmacSHA256(policyNumber + CLIENT_ID, CLIENT_SECRET);
  let sig = CryptoJs.enc.Base64.stringify(hash);
  var wordArray = CryptoJs.enc.Utf8.parse(CLIENT_ID + ':' + CLIENT_SECRET);
  var base64 = CryptoJs.enc.Base64.stringify(wordArray);

  return axios({
    method: 'post',
    url: ISSUER + '/token',
    data: querystring.stringify({
      grant_type: GRANT_TYPE,
      signature: sig,
      policyNum: policyNumber,
      zipCode
    }),
    headers: {
      'Accept': 'application/json, application/x-www-form-urlencoded',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic ' + base64
    }
  }).then((res) => {
    let newTokenSet = res.data;
    newTokenSet.expires_at = newTokenSet.expires_in + (Date.now() / 1000);
    newTokenSet.policyNumber = policyNumber;
    newTokenSet.zipCode = zipCode;
    delete newTokenSet.expires_in;
    sessionStorage.setItem(SESSION_STORE_TOKEN_SET, JSON.stringify(newTokenSet));
    return newTokenSet.access_token;
  });
};

/**
 * Return a policy/zip access token for API authorization. If the there's an existing token
 * in sessionStorage that has not expired and matches the policy/zip provided, that is used.
 * Otherwise, a new one was requested.
 *
 * @returns {Promise} for the bearer access token
 */
const getPolicyZipToken = (policyNumber, zipCode) => {
  let tokenSet = JSON.parse(sessionStorage.getItem(SESSION_STORE_TOKEN_SET));

  // if expires_at is g2g, return; else request new
  if (tokenSet && thresholdNotPassed(tokenSet.expires_at)) {
    // if the policyNumber and zipCode are a match for the token, return; else, request new
    if (tokenSet.policyNumber === policyNumber && tokenSet.zipCode === zipCode) {
      return q.resolve(tokenSet.access_token);
    }
  }

  return grantNewToken(policyNumber, zipCode);
};

export default {
  getPolicyZipToken
};



// WEBPACK FOOTER //
// ./src/services/TokenService.js